import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import Message from './Message';
import styles from './messageContainer.module.css';
import { closeMessageAction } from '../../actions';
import { messageType } from '../../constants/types';

const MessageContainer = ({ dispatchCloseMessage, translate, messages }) => {
  if (!messages) return (null);

  const mappedMessages = messages.map((message) => (
    <Message
      key={message.id}
      messageType={message.messageType}
      details={message.details}
      translate={translate}
      text={message.text}
      close={() => dispatchCloseMessage(message.id)}
    />
  ));
  return (<div className={styles.messageContainer}>{mappedMessages}</div>);
};

const mapStateToProps = (state) => {
  if (state.messages.length) {
    return {
      messages: state.messages
    };
  }
  return { messages: [] };
};

const mapDispatchToProps = (dispatch) => (
  {
    dispatchCloseMessage: (id) =>
      dispatch(closeMessageAction(id))
  });

MessageContainer.defaultProps = {
  messages: []
};

const { arrayOf, func } = PropTypes;
MessageContainer.propTypes = {
  messages: arrayOf(messageType),
  translate: func.isRequired,
  dispatchCloseMessage: func.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(MessageContainer);
